<template>
  <b-row>
    <b-col v-if="application !== null">
      <b-overlay rounded="sm" :show="loading">
        <b-col>
          <b-row>
            <b-col>
            <span style="font-size: 30px; font-weight: bold">
              {{application.title || application.newName}}
            </span>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col cols="12">
              <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                <thead>
                <tr class="bg-gray-pale">
                  <td colspan="12" class="px-2 py-2">Copyright Details</td>
                </tr>
                <tr>
                  <th class="px-2 py-1">Tracking Number</th>
                  <th class="px-2 py-1">Title</th>
                  <th class="px-2 py-1">Status</th>
                  <th class="px-2 py-1">Is Derivative</th>
                  <th class="px-2 py-1">Submission Date</th>
                </tr>
                </thead>
                <tbody>
                <tr style="border: solid 1px #dedede;" >
                  <td class="px-2 py-1">
                    <span class="text-gray">{{application.trackingNumber || application.trackingNo}}</span>
                  </td>
                  <td class="px-2 py-1">
                    {{application.title || application.newName}}
                  </td>
                  <td class="px-2 py-1">
                    <span class="text-blue text-capitalize">{{application.status ? application.status.toLowerCase().replaceAll("_", " ") : ''}}</span>
                  </td>
                  <td class="px-2 py-1">
                    <span class="text-gray">{{isDerivative(application.isDerivativeWork)}}</span>
                  </td>
                  <td class="px-2 py-1">
                  <span class="text-gray italic">
                    {{dateTimeFormat(application.createdAt)}}
                  </span>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>

          <b-row class="mt-1" v-if="application.payment">
            <b-col cols="12">
              <PRNViewer v-if="application.status !== 'DRAFT'" :tracking-number="application.trackingNumber || application.trackingNo" :prn="application.payment.prn"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <CopyrightPopupDetails ref="details" :application="application"/>
            </b-col>
          </b-row>
        </b-col>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment/moment";
import PRNViewer from "@/views/home/commons/PRNViewer.vue";
import CopyrightPopupDetails from "@/views/home/services/copyright/submissions/components/CopyrightPopupDetails.vue";

export default {
  name: "CopyrightDetails",
  components: {CopyrightPopupDetails, PRNViewer },
  props:{
    trackingNumber:String
  },
  data(){
    return{
      application:null,
      loading:true,
    }
  },
  mounted() {
    this.fetchCopyrightByTrackingNumber(this.trackingNumber)
  },
  methods:{
    ...mapActions(["fetchCopyrightByTrackingNumber"]),
    isDerivative(val) {
      if (typeof val === 'object' && val !== null) {
        return val.Valid && val.Bool ? 'Yes' : 'No';
      }
      return val ? 'Yes' : 'No';
    },
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    dateTimeFormat(date){
      return moment(date).format("DD-MM-YYYY h:mmA")
    },
  },
  computed:{
    ...mapGetters(["getCopyright", "getCopyrightError"])
  },
  watch:{
    getCopyright(data){
      this.loading = false
      this.application = data
    },
    getCopyrightError(){
      this.loading = false
      this.errorToast("Error", "Failed to get application details")
    }
  }
};
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>
